import { render, staticRenderFns } from "./CertificateStatistics.vue?vue&type=template&id=92ddb314"
import script from "./CertificateStatistics.vue?vue&type=script&lang=ts"
export * from "./CertificateStatistics.vue?vue&type=script&lang=ts"
import style0 from "./CertificateStatistics.vue?vue&type=style&index=0&id=92ddb314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports